/** One year in seconds (for cookie max-age). */
export const ONE_YEAR_SECONDS = 31536000;

export interface SetCookieOptions {
  maxAge?: number;
  path?: string;
  sameSite?: 'Strict' | 'Lax' | 'None';
}

/**
 * Gets the value of a cookie by name.
 * @returns The cookie value or null if not found.
 */
export function getCookie(name: string): string | null {
  const match = document.cookie
    .split(';')
    .map((c) => c.trim())
    .find((c) => c.startsWith(`${name}=`));
  if (!match) return null;
  const value = match.slice(name.length + 1);
  return value === '' ? null : decodeURIComponent(value);
}

/**
 * Sets a cookie with the given name and value.
 */
export function setCookie(name: string, value: string, options: SetCookieOptions = {}): void {
  const { maxAge = ONE_YEAR_SECONDS, path = '/', sameSite = 'Strict' } = options;
  const encoded = encodeURIComponent(value);
  let cookie = `${name}=${encoded}; path=${path}; SameSite=${sameSite}`;
  if (maxAge > 0) {
    cookie += `; max-age=${maxAge}`;
  }
  document.cookie = cookie;
}
